<template>
    <div class="picture-edit-model">
        <TitleBaseBox :title="title" class="model-wrap" @close="close" @cancel="cancelClick" @confirm="confirmClick">
            <div class="model-content">
                <ItemPanel :text="editConfig.bigPic" :isRequired="true">
                    <CoverPanel
                        class="image-upload"
                        :noCoverIcon="editConfig.noCoverIcon"
                        :imageUrl="cardImage"
                        :operateIcons="editConfig.operateIcons"
                        :viewIcon="editConfig.viewIcon"
                        ishorizontal="true"
                        @uploadCover="uploadCover"
                        @operatorSelect="operatorSelect"
                        @imageClick="showBigPicture"
                    />
                </ItemPanel>
                <ItemPanel :text="editConfig.pictureName" :isRequired="true">
                    <IconInput class="model-input" :initValue="pictureName" @inputChange="nameChange" :placeholder="editConfig.namePlaceholder" />
                </ItemPanel>
                <ItemPanel :text="editConfig.pictureTag" :isRequired="true">
                    <TagSelect
                        class="model-tag-select"
                        type="image"
                        :placeholder="editConfig.tagPlaceholder"
                        :selected="pictureTag"
                        @clickSelect="selectHandler"
                    ></TagSelect>
                </ItemPanel>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import { ParamError } from "@/views/zhiji/js/common/errors.js";

import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";
import ItemPanel from "@/views/zhiji/components/materialLibrary/ItemPanel";
import CoverPanel from "@/views/zhiji/components/coverPanel/CoverPanel";
import TagSelect from "@/views/zhiji/components/materialLibrary/TagSelect";
import ImageViewModal from "@/views/zhiji/components/questionEdit/modals/ImageViewModal";
import ImageClipModal from "@/views/zhiji/components/imageUpload/ImageClipModal";
import { pictureEditConfig } from "@/views/zhiji/components/materialLibrary/materialLibraryConfig.js";
import i18n from "@/i18n";

export default {
    name: "PictureEditModel",
    props: ["data"],
    components: {
        TitleBaseBox,
        ItemPanel,
        IconInput,
        CoverPanel,
        TagSelect
    },
    data() {
        return {
            pictureTag: (this.data.pictureData && this.data.pictureData.tagIds) || "",
            pictureName: (this.data.pictureData && this.data.pictureData.title) || "",
            cardImage: (this.data.pictureData && this.data.pictureData.url) || ""
        };
    },
    computed: {
        title() {
            return this.data.type == "add" ? this.$t("zhiji.materialLibrary.addPic") : this.$t("zhiji.materialLibrary.editPic");
        },
        editConfig() {
            return pictureEditConfig();
        }
    },
    methods: {
        selectHandler(data) {
            this.pictureTag = data;
        },
        nameChange(newVal) {
            this.pictureName = newVal;
        },
        uploadCover() {
            this.uploadImage((imageUrl, imageName) => {
                this.cardImage = imageUrl;
                // eslint-disable-next-line no-unused-expressions
                this.data.type === 'add' ? (this.pictureName = imageName.replace(/(.*\/)*([^.]+).*/ig, '$2')) : '';
        });
        },
        showBigPicture() {
            this.cardImage &&
                this.$store.commit("zhiji/showModal", {
                    type: ImageViewModal,
                    data: {
                        url: this.cardImage
                    }
                });
        },
        operatorSelect(type) {
            if (type == 'update') {
                this.uploadImage((imageUrl, imageName) => {
                    this.cardImage = imageUrl;
                    // eslint-disable-next-line no-unused-expressions
                    this.data.type === 'add' ? (this.pictureName = imageName.replace(/(.*\/)*([^.]+).*/ig, '$2')) : '';
                });
            }
        },
        uploadImage(cb) {
            this.$store.commit("zhiji/showModal", {
                type: ImageClipModal,
                data: {
                    openFile: openFile => {
                        this.openFile = openFile;
                    },
                    confirm: (url, name) => {
                        cb && cb(url, name);
                    },
                    cancel: () => {
                        this.openFile = null;
                    },
                    needClip: false
                }
            });

            // 打开组件时弹出文件选择，只有在isTrusted事件里面可以触发, HACK
            setTimeout(() => {
                this.openFile();
                this.openFile = null;
            }, 500);
        },
        close(event) {
            this.$emit("closeModal");
        },
        cancelClick() {
            !this.data.childModel && this.close();
        },
        confirmClick() {
            let checkedData = {
                pictureName: this.pictureName,
                cardImage: this.cardImage,
                pictureTag: this.pictureTag
            };
            new Promise(function(resolve, reject) {
                checkImagesData(checkedData);
                resolve();
            })
                .then(() => {
                    this.savePictureData();
                })
                .catch(err => {
                    if (err.errorType == "ParamError" || err.errorType == "ServerRespError") {
                        this.$store.dispatch("zhiji/showModal", {
                            type: "MessageModal",
                            data: {
                                type: "error",
                                message: err.message
                            }
                        });
                    }
                });
        },
        savePictureData() {
            let handler = {
                add: this.addSinglePicture,
                edit: this.editPicture
            };

            handler[this.data.type].call(null);
        },
        addSinglePicture() {
            this.zhiji
                .requestByServiceName("addSinglePicture", {
                    pictureName: this.pictureName,
                    cardImage: this.cardImage,
                    pictureTag: this.pictureTag
                })
                .then(result => {
                    if (result.errCode) {
                        this.successTips(result.errMessage);
                        return;
                    }
                    this.data.confirm && this.data.confirm(result);
                    this.updatePictureList();
                    this.close();
                });
        },
        editPicture() {
            this.zhiji
                .requestByServiceName("updateOnePicture", {
                    pictureName: this.pictureName,
                    cardImage: this.cardImage,
                    pictureTag: this.pictureTag,
                    pictureId: this.data.pictureData.id
                })
                .then(result => {
                    if (result.errCode) {
                        this.successTips(result.errMessage);
                        return;
                    }
                    this.data.confirm && this.data.confirm(result);
                    this.updatePictureList();
                    this.close();
                });
        },
        successTips(tipText) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: tipText,
                    cancel: () => {},
                    confirm: () => {}
                }
            });
        },
        updatePictureList() {
            this.$store.dispatch("zhiji/queryPictureList", {
                page: 1,
                size: 15
            });
        }
    }
};

// 校验图片编辑参数
function checkImagesData(data) {
    if (!data.pictureName) {
        throw new ParamError(i18n.t("zhiji.materialLibrary.picNameCheck"));
    }

    if (!data.pictureTag) {
        throw new ParamError(i18n.t("zhiji.materialLibrary.picTagCheck"));
    }

    if (!data.cardImage) {
        throw new ParamError(i18n.t("zhiji.materialLibrary.picCoverCheck"));
    }
}
</script>

<style lang="less">
.picture-edit-model {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    .model-wrap {
        .model-content {
            width: 860px;
            padding: 4px 4px 0 4px;
            font-size: 12px;
            box-sizing: border-box;
            .model-input {
                width: 600px;
                height: 32px;
                background: #ffffff;
                border: 0;
                & > input {
                    border-color: #d8e4f0;
                    border-radius: 4px;
                }
                & > input:focus {
                    border-color: #2088f3;
                }
            }
            .model-tag-select {
                width: 600px;
            }
            .image-upload {
                width: 142px;
                height: 107px;
                margin-right: 4px;
                background: #fafbfd;
                border: 1px solid #d8e4f0;
                border-radius: 4px;
                cursor: pointer;

                .cover-image-panel {
                    border-radius: 4px;
                    overflow: hidden;
                    & > img {
                        max-width: none;
                    }
                }
            }
        }
        .buttons {
            padding: 20px !important;
            background: #fafbfd;
            border-top: 1px solid #d8e4f0;
        }
    }
}
</style>
